import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Topbar } from "@components";
import { EmptyBox, Loader, NoResultText, RootContainer, ShareItemsContainer } from "./ShareSummary.style";
import ShareITem from "./ShareItem/ShareItem";
import { PUBLIC_ROUTE } from "@router/route.constants";
import { api } from "@api";
import { useDispatch } from "react-redux";
import { openAlert } from "@redux/app/appSlice";
import { useTranslation } from "react-i18next";
import { Spin } from "antd";
import { EmptyShareFilled } from '@assets';

const ShareSummary = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [share_summary, setShareSummary] = useState([]);

  useEffect(() => {
    getShareSummary();

    // eslint-disable-next-line
  }, []);

  const getShareSummary = () => {
    setLoading(true);
    api
      .getShareSummary()
      .then(({ share_summary }) => {
        setLoading(false);
        setShareSummary(share_summary);
      })
      .catch((errorMsg) => {
        setLoading(false);
        showAlert({
          message: errorMsg,
          isError: true,
        });
      });
  }

  const showAlert = (data) => {
    dispatch(openAlert(data));
  };

  const goBack = () => {
    navigate(`/${PUBLIC_ROUTE.PROFILE}`);
  };

  const EmptyCard = () => (
    <EmptyBox>
      <EmptyShareFilled />
      <NoResultText>{t("share.emptyMessage")}</NoResultText>
    </EmptyBox>
  );

  return (
    <>
      <Topbar title={t("profile.shareHistory")} goBack={goBack} />
      {loading ? (
        <Loader>
          <Spin />
        </Loader>
      )
        : share_summary.length === 0
          ? <EmptyCard />
          : (
            <RootContainer>
              <ShareItemsContainer>
                {share_summary.map((item, index) => (
                  <ShareITem key={index} item={item} />
                ))}
              </ShareItemsContainer>
            </RootContainer>
          )
      }
    </>
  );
};

export default ShareSummary;
